import Grid from '@mui/material/Grid';
import { withStyles } from 'utils/styles';
import BaseTable from 'components/Tables/BaseTable';
import { actions as actionsAccounts } from 'ducks/accounts';
import { alertError } from 'ducks/alerts';
import React from 'react';
import { connect } from 'react-redux';
import { getImmutableStoreData } from 'selectors/generic';
import theme from 'source/theme';

const styles = theme => ({
  text: {
    marginBottom: theme.spacing(1)
  }
});

const columns = [
  { title: 'Conta cliente', field: 'name' },
  { title: 'NIF', field: 'vat_number' },
  { title: 'Morada', field: 'address' }
];

const Component = props => {
  const { accounts, classes } = props;
  const { create, fetchAll, remove, update } = props;

  return (
    <Grid size={12}>
      <BaseTable
        title="GESTÃO DE CLIENTES ReachOK"
        columns={columns}
        data={accounts}
        editable={{
          onRowAdd: (newData, oldData) => create(newData).then(() => fetchAll()),
          //onRowUpdate: (newData, oldData) => update(newData.id, newData).then(() => fetchAll())
          onRowDelete: (newData) => remove(newData.id).then(() => fetchAll())
        }}
      />
    </Grid>
  );
};

const makeMapStateToProps = () => {
  // Cloned, like every other table in the app. material-table writes its own
  // bookkeeping onto the rows it is given, and the rows in the store are now
  // the ones `models` holds - there is no second copy left to absorb that.
  //
  // Built once rather than inside mapStateToProps: createSelector holds one
  // result, so a selector made on each call has an empty cache every time and
  // deep-clones the whole slice per render. The factory itself is only this
  // file matching the other fifty - it gives each instance its own memo, which
  // earns its keep for a selector that reads ownProps and nothing here does.
  const immutableAccounts = getImmutableStoreData('accounts');
  const mapStateToProps = state => ({
    accounts: immutableAccounts(state)
  });
  return mapStateToProps;
};

const mapDispatchToProps = dispatch => ({
  alertError: error => dispatch(alertError(error)),
  create: data => dispatch(actionsAccounts.createPromise(data)),
  update: (id, data) => dispatch(actionsAccounts.updatePromise(id, data)),
  remove: id => dispatch(actionsAccounts.removePromise(id)),
  fetchAll: (params, meta) => dispatch(actionsAccounts.fetchAll(params, meta))
});


export default connect(makeMapStateToProps, mapDispatchToProps)(withStyles(styles, theme)(Component));
